















































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSformTable from '@/components/AMSformTable.vue';
import AMSProductImg from '@/components/AMSProductImg.vue';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import { allStaff } from '@/api/staff';
import { stockExport } from '@/api/report';
import Utils from '@/utils/utils';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';
import { getModuleName } from '@/utils/utils';
@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-formtable': AMSformTable,
    'ams-product': AMSProduct
  }
})
export default class StockReport extends Vue {
  breadItems = [
    {
      text: '报表管理',
      disabled: false,
      href: 'materials'
    },
    {
      text: '库存报表',
      disabled: true
    }
  ];
  api: string = '/api/Report/StockReport';
  outStockItem = [
    // { value: '', text: '全部' },
    { value: 'PurchaseReturn', text: '采购退货' },
    { value: 'Order', text: '销售出库' },
    { value: 'TransferOut', text: '调拨出库' },
    { value: 'Loss', text: '盘亏出库' },
    { value: 'OtherOut', text: '其他出库' },
    { value: 'MaterialOrder ', text: '物料申请出库' }
  ];
  inStockItem = [
    // { value: '', text: '全部' },
    { value: 'Purchase', text: '采购入库' },
    { value: 'Profit', text: '盘盈入库' },
    { value: 'Return', text: '退货入库' },
    { value: 'Transfer', text: '调拨入库' },
    { value: 'Other', text: '其他入库' }
  ];
  form: any = {
    operatorId: '',
    approvePersonId: '',
    startTime: moment(
      moment()
        .subtract(1, 'months')
        .startOf('month')
        .format('YYYY-MM-DD')
    ).toISOString(),
    endTime: '',
    categoryId: '',
    outStock: [''],
    inStock: ['']
    // endTime: moment(
    //   moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    // ).toISOString()
  };
  startTimeStr: string = moment()
    .subtract(1, 'months')
    .startOf('month')
    .format('YYYY-MM-DD');
  endTimeStr: string = '';
  // endTimeStr: string = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
  //   表头
  headers: any[] = [];
  //开始时间 弹窗
  beginTime: boolean = false;
  //结束时间 弹窗
  endTime: boolean = false;
  /**当前时间 */
  currentTime: string = moment().format('YYYY-MM-DD');
  /**列表数据 */
  datas: any[] = [];
  //列表合计
  statisticsDataRows: any[] = [];
  staffList: Array<object> = [];

  @Watch('startTimeStr', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.startTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('endTimeStr', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.endTime = newValue ? moment(newValue).toISOString() : '';
  }

  created() {
    this.getStaff();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.endTimeStr = this.form.endTime ? moment(this.form.endTime).format('YYYY-MM-DD') : '';
      this.startTimeStr = this.form.startTime ? moment(this.form.startTime).format('YYYY-MM-DD') : '';
    } else {
      this.initForm();
    }
  }

  handleGetOtherData(obj: any) {
    const data = obj.items;
    if (data) {
      const columns = data.columns;
      if (columns && Object.keys(columns).length > 0) {
        let h: any[] = [];
        for (const key in columns) {
          const k = key;
          const v = columns[k];
          if (v === '商品') {
            h.push({
              width: 170,
              text: v,
              value: k,
              align: 'left',
              render: (h: any, param: any) => {
                let text = param.row.product;
                text = text.replace('\r\n', '<br />');
                return h('div', {
                  props: {},
                  domProps: {
                    innerHTML: text
                  }
                });
              }
            });
          } else {
            h.push({ text: v, value: k, align: 'left', width: 140 });
          }
        }
        h.push({
          text: '操作',
          value: 'actions',
          align: 'center',
          width: 150,
          isDetail: [
            {
              callBack: (btn: any, row: any, key: string) => {
                this.toDetails(row);
              },
              text: '查看明细',
              color: '#1ABC9C',
              isShowBtn: (row: any) => {
                return Utils.isPermission('InventoryManager.StockDetail');
              }
            }
          ]
        });
        this.headers = h;
      }

      const dataRows = data.dataRows.items;
      if (columns && dataRows.length > 0) {
        const row = dataRows[0];
        this.headers.forEach(element => {
          const k = element.value;
          // element.isCurrency = typeof row[k] === 'number';
          element.align = typeof row[k] === 'number' ? 'right' : 'left';
        });
        this.datas = dataRows;
      }

      const reportName = data.reportName;

      const statisticsDataRows = data.statisticsDataRows;
      this.statisticsDataRows = statisticsDataRows;
    }
  }

  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }

  initForm() {
    this.form = {
      operatorId: '',
      approvePersonId: '',
      startTime: moment(
        moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD')
      ).toISOString(),
      endTime: moment(
        moment()
          .subtract(1, 'months')
          .endOf('month')
          .format('YYYY-MM-DD')
      ).toISOString()
    };
    this.startTimeStr = moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD');
    this.endTimeStr = moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD');
  }
  //导出
  handleExport() {
    const params = { ...this.form, exportExcel: true };
    stockExport(params)
      .then(response => {
        AppStore.ShowSuccess('下载成功');
      })
      .catch(error => {
        AppStore.ShowError('下载失败');
      });
  }
  onOperatorClear() {
    setTimeout(() => {
      this.form.operatorId = '';
    }, 1);
  }
  onApproveClear() {
    setTimeout(() => {
      this.form.approvePersonId = '';
    }, 1);
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  toDetails(row: any) {
    const productName = row.item.product.split('\r\n')[1] || row.item.product;
    this.$router.push({
      name: 'stockDetail',
      query: {
        id: row.item.productId
      },
      params: {
        name: productName
      }
    });
  }
}
